function getElementValue(nameAttribute) {
    var elementValue = '';

    // Check if element is radio button or checkbox
    if ($("[name='" + nameAttribute + "']").is(':radio') || $("[name='" + nameAttribute + "']").is(':checkbox'))
        elementValue = $("[name='" + nameAttribute + "']:checked").val();
    // For multiple checkboxes
    else if ($("[name='" + nameAttribute + "[]']").is(':checkbox')) {
        $("[name='" + nameAttribute + "[]']:checked").each(function () {
            elementValue = $(this).val();
        });
    }
    else
        elementValue = $("[name='" + nameAttribute + "']").val();

    if (typeof elementValue === 'undefined')
        elementValue = '';

    return elementValue;
}

function currentElementIsInvalid(currentElementValue, currentElementNameAttribute, val) {
    if (currentElementValue === '') {
        $("[name='" + currentElementNameAttribute + "']").addClass('is-invalid');
        $(val).removeClass('d-none').addClass('d-block');
        event.preventDefault();
    }
}

$('form').on('submit', function(event) {
    var all = $(this).find('.invalid-feedback[data-dependsonformelements]');
    var formId = $(this).attr('id');

    $.each(all, function(key, val) {

        if ($(val).data('dependsonformelements') !== '') {

            var data = $(val).data('dependsonformelements');
            var currentElementIdentifier = $(val).data('formelementidentifier');
            var currentElementNameAttribute = '--' + formId + '[' + currentElementIdentifier + ']';
            // Set separator as set in Field.html tmsformbootstrap ViewHelper
            data = data.split(',');


            var currentElementValue = getElementValue(currentElementNameAttribute);

            for (var i = 0; i < data.length; i++) {

                // name attribute example --3442-2342[2342-2342]
                var nameAttribute = '--' + formId + '[' + data[i] + ']';
                var elementValue = getElementValue(nameAttribute);

                if ($(val).data('dependsonformelementvalue') !== '') {
                    if ($(val).data('dependsonformelementvalue') === elementValue) {
                        currentElementIsInvalid(currentElementValue, currentElementNameAttribute, val);
                    }
                }
                else {
                    if (elementValue !== '') {
                        currentElementIsInvalid(currentElementValue, currentElementNameAttribute, val);
                    }
                }
            }

        }
    });

});